import { useDocumentListener } from './useDocumentListener';
export function useFocusTrap(focusScope) {
    useDocumentListener('keydown', (e) => {
        var _a;
        if (!((_a = focusScope.getRootNode()) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement))) {
            return;
        }
        if (e.key === 'Tab' && !e.altKey && !e.ctrlKey && !e.metaKey) {
            e.preventDefault();
            const rootNode = focusScope.getRootNode();
            let currentNode = document.activeElement;
            if (!currentNode || !(rootNode === null || rootNode === void 0 ? void 0 : rootNode.contains(currentNode))) {
                currentNode = rootNode;
            }
            focusScope.focusNextDescendant(currentNode, e.shiftKey);
        }
    });
}
//# sourceMappingURL=useFocusTrap.js.map